export const environment = {
  production: true,
  appInsightsConnectionString: 'InstrumentationKey=ede10aaa-54d6-486c-8dd4-37668cce2cb1;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/'
};
